import { render, staticRenderFns } from "./Highlightable.vue?vue&type=template&id=1919a1c4&scoped=true&"
import script from "./Highlightable.vue?vue&type=script&lang=js&"
export * from "./Highlightable.vue?vue&type=script&lang=js&"
import style0 from "./Highlightable.vue?vue&type=style&index=0&id=1919a1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919a1c4",
  null
  
)

export default component.exports